
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/DashboardBar/DashboardBar.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./DashboardBar.html');
        
        var script = require('./DashboardBar.ts').default;
        module.exports = require('./DashboardBar.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    